import { useDispatch } from "react-redux";
import InventoryAdjustmentDetailService from "../../../services/inventory/adjustment/InventoryAdjustmentDetailService";
import { clearSelectedAdjustmentDetail, setAdjustmentLoaded, setSelectedAdjustmentDetail } from "../../../store/slices/inventory/adjustment/inventoryAdjustmentSlice";
import { AppDispatch } from "../../../store/store";
import useAlerts from "../../useAlerts";
import useApiErrorHandler from "../../useApiErrorHandler";
import useLoading from "../../useLoading";
import useModals from "../../useModals";
import { useInventoryAdjustment } from "../useInventoryAdjustment";

export const useInventoryAdjustmentDetail = () => {
    const { showLoadingIndicator, hideLoadingIndicator } = useLoading();
    const dispatch: AppDispatch = useDispatch();
    const { show } = useAlerts();
    const { openModal } = useModals();
    const { handle } = useApiErrorHandler();

    const {
        form,
        setForm,
        setSubmitting,
    } = useInventoryAdjustment();

    /* ───────────────────────────────
     * ➕ ADD DETAIL
     * ─────────────────────────────── */
    const addDetail = async (payload: any) => {
        if (!form?.id) return;

        try {
            setSubmitting(true);
            showLoadingIndicator();

            const response =
                await InventoryAdjustmentDetailService.addDetail(form.id, payload);

            console.log(response);

            const { type, title, message, statusCode, data } = response;

            if (statusCode === 200 || statusCode === 201) {
                // ✅ Backend retorna FORM COMPLETO
                setForm(data);

                openModal(type, {
                    title,
                    message,
                });
            } else {
                show("error", "Error", "No se pudo agregar el producto.");
            }
        } catch (error: any) {
            handle(error);
        } finally {
            setSubmitting(false);
            hideLoadingIndicator();
        }
    };

    /* ───────────────────────────────
     * ✏️ UPDATE DETAIL
     * ─────────────────────────────── */
    const updateDetail = async (detailId: number, payload: any) => {
        try {
            setSubmitting(true);
            showLoadingIndicator();

            const response =
                await InventoryAdjustmentDetailService.updateDetail(detailId, payload);

            console.log(response)
            const { statusCode, data } = response;

            if (statusCode === 200) {
                setForm(data);
                dispatch(setAdjustmentLoaded(false));
                dispatch(clearSelectedAdjustmentDetail());
            } else {
                show("error", "Error", "No se pudo actualizar el producto.");
            }
        } catch (error: any) {
            handle(error);
        } finally {
            setSubmitting(false);
            hideLoadingIndicator();
        }
    };

    /* ───────────────────────────────
   * 🔍 GET DETAIL BY ID (EDIT)
   * ─────────────────────────────── */
    const getDetailById = async (detailId: number) => {
        try {
            showLoadingIndicator();

            const response =
                await InventoryAdjustmentDetailService.getById(detailId);

            const { statusCode, data } = response;

            if (statusCode === 200) {
                // 🔥 Guardamos el detalle para edición
                dispatch(setSelectedAdjustmentDetail(data));
                dispatch(setAdjustmentLoaded(true));
            } else {
                show('error', 'Error', 'No se pudo obtener el detalle.');
            }
        } catch (error: any) {
            handle(error);
        } finally {
            hideLoadingIndicator();
        }
    };

    /* ───────────────────────────────
     * ❌ DELETE DETAIL
     * ─────────────────────────────── */
    const deleteDetailById = async (detailId: number) => {
        try {
            setSubmitting(true);
            showLoadingIndicator();

            const response =
                await InventoryAdjustmentDetailService.deleteDetail(detailId);
            console.log(response);

            const { statusCode, data } = response;

            if (statusCode === 200) {
                setForm(data);
            } else {
                show("error", "Error", "No se pudo eliminar el producto.");
            }
        } catch (error: any) {
            handle(error);
        } finally {
            setSubmitting(false);
            hideLoadingIndicator();
        }
    };

    return {
        addDetail,
        updateDetail,
        deleteDetailById,
        getDetailById,
    };
};
